<template>
  <div>
    
  </div>
</template>

<script>


  export default {
    name: "rightSiteMenu"
  }
</script>
